var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teacher-home"},[_c('topNav',{ref:"topNav"}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }